import i18next from 'i18next';
import { SearchType } from '../useSearch';

const Translation = {
  singular: {
    retailers_cms: i18next.t('search.result.cmsContent.singular'),
    cars: i18next.t('search.result.cars.singular'),
  },
  plural: {
    retailers_cms: i18next.t('search.result.cmsContent.plural'),
    cars: i18next.t('search.result.cars.plural'),
  },
};

export const translateHits = (hits: number | undefined, indexType: SearchType) =>
  `${i18next.t('search.showNumberOfCustomUnit', {
    count: hits || 0,
    unit: hits === 1 ? Translation.singular[indexType] : Translation.plural[indexType],
  })}`;

export default Translation;
